<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="-" :loginShow="loginShow" :gotoIndex="gotoIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>个人中心</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="personal">
            <personal pageType="deregister"></personal>
            <div class="personal_right">
              <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign6.png"> 账号注销</span></h2>

              <div class="deregister-container">
                <div class="warning-section">
                  <div class="warning-box">
                    <div class="warning-icon">⚠️</div>
                    <div class="warning-content">
                      <h4 class="warning-title">温馨提示</h4>
                      <p class="warning-text">
                        账号注销为不可逆操作，提交注销后账号及登录相关信息将永久删除，账号无法找回、无法恢复，请谨慎确认。
                      </p>
                      <ul class="warning-details">
                        <li>• 您的个人信息将被永久删除</li>
                        <li>• 您的办件记录、预约信息将无法查询</li>
                        <li>• 您的消息通知、评价记录将被清空</li>
                        <li>• 您将无法使用该账号再次登录</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="confirm-section">
                  <label class="checkbox-label">
                    <input type="checkbox" v-model="confirmChecked" class="custom-checkbox">
                    <span class="checkbox-text">我已阅读并理解上述提示，确认要注销账号</span>
                  </label>
                </div>

                <div class="button-section">
                  <button
                    class="deregister-btn"
                    :disabled="!confirmChecked || isSubmitting"
                    @click="handleDeregister"
                  >
                    {{isSubmitting ? '处理中...' : '确认注销'}}
                  </button>
<!--                  <button class="cancel-btn" @click="handleCancel">取消</button>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
import headers from "../../components/Headers";
import fixedDiv from "../../components/FixedDiv";
import footers from "../../components/Footer";
import personal from "../../components/Personal";
export default {
  name: "Deregister",
  components: {
    headers, fixedDiv, footers, personal
  },
  data(){
    return{
      user_info:{},
      loginShow:false,
      gotoIndex:false,
      confirmChecked: false,
      isSubmitting: false,
    }
  },
  mounted() {
    var userInfo=this.$cookies.get('userInfo')
    if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){
      this.loginShow=true;
      this.gotoIndex=true;
    }
  },
  methods:{
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    },

    handleDeregister() {
      if (!this.confirmChecked) {
        this.$message({
          message: '请先勾选确认选项',
          type: 'warning',
          duration: 2000
        });
        return;
      }

      const tt = this;
      this.$confirm('此操作将永久删除您的账号及相关数据，是否继续？', '二次确认', {
        confirmButtonText: '确定注销',
        cancelButtonText: '再想想',
        type: 'error',
        closeOnClickModal: false,
      }).then(() => {
        tt.isSubmitting = true;

        tt.$https.post("/api/pu/deregisterAccount.do", {}, response => {
          if (response.status === 200 && response.data.code === 200) {
            tt.$message({
              message: '账号注销成功',
              type: 'success',
              duration: 2000,
              onClose: () => {
                tt.logoutAndRedirect();
              }
            });
          } else {
            tt.isSubmitting = false;
            tt.$message({
              message: response.data.msg || '注销失败，请稍后重试',
              type: 'error',
              duration: 3000
            });
          }
        });
      }).catch(() => {

      });
    },
    logoutAndRedirect() {
      this.$cookies.remove('userInfo');
      this.$cookies.remove('userId');
      this.$cookies.remove('token');
      this.$cookies.remove('isLegal');

      let threeTokenId = this.$cookies.get('threeTokenId');
      if(threeTokenId && threeTokenId !== ''){
        this.$cookies.remove('threeTokenId');
      }

      this.urlTo('home');

      setTimeout(() => {
        window.location.reload();
      }, 500);
    },
    handleCancel() {
      this.$router.back();
    }
  }
}
</script>

<style scoped>
.deregister-container {
  padding: 30px 40px;
}

.user-info-section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 18px;
  color: #2e2e2e;
  margin-bottom: 20px;
  padding-left: 10px;
  border-left: 3px solid #2c62ec;
}

.info-list {
  padding: 20px 30px;
  background: #f9f9f9;
  border-radius: 5px;
}

.info-list dd {
  margin-bottom: 15px;
  overflow: hidden;
  line-height: 30px;
}

.info-list .label {
  float: left;
  width: 120px;
  text-align: right;
  color: #666;
  font-weight: 500;
}

.info-list .value {
  float: left;
  margin-left: 20px;
  color: #2e2e2e;
}

.warning-section {
  margin: 30px 0;
}

.warning-box {
  background: #fff3e0;
  border: 2px solid #ff9800;
  border-radius: 8px;
  padding: 25px;
  display: flex;
  align-items: flex-start;
}

.warning-icon {
  font-size: 32px;
  margin-right: 15px;
  flex-shrink: 0;
}

.warning-content {
  flex: 1;
}

.warning-title {
  font-size: 18px;
  color: #ff6f00;
  margin-bottom: 12px;
  font-weight: bold;
}

.warning-text {
  font-size: 15px;
  color: #e65100;
  line-height: 1.8;
  margin-bottom: 15px;
  font-weight: 500;
}

.warning-details {
  list-style: none;
  padding: 0;
  margin: 0;
}

.warning-details li {
  font-size: 14px;
  color: #f57c00;
  line-height: 28px;
  padding-left: 5px;
}

.confirm-section {
  margin: 30px 0;
  padding: 20px;
  background: #fafafa;
  border-radius: 5px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 15px;
}

.custom-checkbox {
  width: 18px;
  height: 18px;
  margin-right: 10px;
  cursor: pointer;
  -webkit-appearance: none;
  border: 2px solid #2c62ec;
  border-radius: 3px;
  outline: none;
  position: relative;
}

.custom-checkbox:checked {
  background-color: #2c62ec;
  background-image: url('../../../static/images/checkbox_icon.png');
  background-repeat: no-repeat;
  background-position: center;
}

.checkbox-text {
  color: #333;
  font-weight: 500;
}

.button-section {
  margin-top: 40px;
  text-align: center;
  padding-top: 20px;
}

.deregister-btn {
  width: 180px;
  height: 48px;
  background: #f44336;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  margin-right: 20px;
  transition: all 0.3s;
}

.deregister-btn:hover:not(:disabled) {
  background: #d32f2f;
}

.deregister-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}

.cancel-btn {
  width: 180px;
  height: 48px;
  background: #fff;
  color: #666;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
}

.cancel-btn:hover {
  border-color: #2c62ec;
  color: #2c62ec;
}
</style>




// WEBPACK FOOTER //
// src/pages/personal/Deregister.vue